import { AnswerTypes } from 'Stories/components/Form/answerTypes';
import { WellBeingAssessmentQuestionType } from './wellbeingQuestionType';

export const questions = [
  {
    name: 'b9cbd7e5-b5f7-4c49-b399-30a7acbee231',
    textId: 'screenings.form.adult-well-being-questions-1',
    questionType: WellBeingAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: '9727cc89-ba4f-4c18-bafc-6aceaf083962',
        textId: 'common.never',
      },
      {
        name: 'e4328855-c073-476d-aeaa-80a2dae13045',
        textId: 'common.rarely',
      },
      {
        name: '9cea49e6-46e5-4ae4-b002-2058b09a6e29',
        textId: 'common.sometimes',
      },
      {
        name: 'c33fde79-7208-4fc8-9b31-55f06436de98',
        textId: 'common.often',
      },
      {
        name: '6c289e0c-cf61-4e6a-8158-cd3ae5bd92eb',
        textId: 'common.always',
      },
    ],
  },
  {
    name: '694278c9-58e2-481a-aa90-8ea16da082c5',
    textId: 'screenings.form.adult-well-being-questions-2',
    questionType: WellBeingAssessmentQuestionType.YESNO,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: 'a565fd2f-78e5-41ca-b9cc-409a2d66ff6d',
        textId: 'common.yes',
      },
      {
        name: 'b474c057-0874-4407-b210-0f818f5105ba',
        textId: 'common.no',
      },
    ],
  },
  {
    name: '8f1ab826-a8b0-4659-bcb3-2795eab19188',
    textId: 'screenings.form.adult-well-being-questions-3',
    questionType: WellBeingAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: '58c84a56-e6a6-456e-9f44-eceb8611d8e9',
        textId: 'common.yes',
      },
      {
        name: '65a0e9ef-a2f1-415f-8572-0cff23fced2d',
        textId: 'common.no',
      },
      {
        name: '59205fc5-19e9-4aa3-ac2c-0ea044e8de7c',
        textId: 'common.dont-know-not-sure',
      },
      {
        name: 'f8ea1b1c-17c8-4723-a0f8-92d2df847d6d',
        textId: 'common.prefer-not-to-answer',
      },
    ],
  },
  {
    name: 'cec7648e-0a79-4601-9c33-dfa81fe47c00',
    textId: 'screenings.form.adult-well-being-questions-4',
    questionType: WellBeingAssessmentQuestionType.SINGLESELECT,
    answerType: AnswerTypes.RADIO,
    options: [
      {
        name: 'f65d30e5-1b5c-47e4-84bb-90f61800ad3b',
        textId: 'screenings.answer.well-being.within-the-past-year',
      },
      {
        name: '0dda67a7-c3b1-4cf7-8d73-04cff12db592',
        textId: 'screenings.answer.well-being.within-the-past-two-years',
      },
      {
        name: 'a1fa0811-a7d0-4e79-9108-6cf29b42980b',
        textId: 'screenings.answer.well-being.within-the-past-five-years',
      },
      {
        name: '75a53fb3-6ee4-4aca-8d72-f12a5b68bd89',
        textId: 'screenings.answer.well-being.five-or-more-years-ago',
      },
    ],
  },
  {
    name: 'fbd56006-7aaa-407b-a192-35a77dceccfc',
    textId: 'screenings.form.adult-well-being-questions-5',
    questionType: WellBeingAssessmentQuestionType.NUMBERTEXT,
    answerType: AnswerTypes.TEXTBOX,
    options: [
      {
        name: '3d39aed6-05a2-4339-a99b-459f3ddd01c3',
        textId: 'screenings.answer.well-being.number-of-days-zero-to-thirty',
      },
      {
        name: '22cc38ed-2a0d-47f9-a424-f65dbba5f37c',
        textId: 'common.none',
      },
    ],
  },
];
